/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  GetWordCloudParams,
  ListWordCloudsParams,
  PaginatedWordClouds,
  SchemaValidationErrorResponse,
  WordCloud,
  WordCloudAddWordRequestInput,
  WordCloudRequestInput
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create WordCloud
 */
export const createWordCloud = (

 signal?: AbortSignal
) => {


      return axiosClient<WordCloud>(
      {url: `/word_clouds/word_clouds`, method: 'POST', signal
    },
      );
    }




export const getCreateWordCloudMutationKey = () => ['createWordCloud'] as const;

export const getCreateWordCloudMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWordCloud>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createWordCloud>>, TError,void, TContext> => {

const mutationKey = getCreateWordCloudMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWordCloud>>, void> = () => {


          return  createWordCloud()
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateWordCloudMutationResult = NonNullable<Awaited<ReturnType<typeof createWordCloud>>>

    export type CreateWordCloudMutationError = ErrorType<void>


    /**
 * @summary Create WordCloud
 */
export const useCreateWordCloud = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWordCloud>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createWordCloud>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreateWordCloudMutationOptions(options), queryClient);
    }
    /**
 * @summary List of WordClouds
 */
export const listWordClouds = (
    params?: MaybeRefOrGetter<ListWordCloudsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedWordClouds>(
      {url: `/word_clouds/word_clouds`, method: 'GET',
        params, signal
    },
      );
    }




export const getListWordCloudsQueryKey = (params?: MaybeRefOrGetter<ListWordCloudsParams>,) => {
    return [
    'word_clouds','word_clouds', ...(params ? [params] : [])
    ] as const;
    }


export const getListWordCloudsQueryOptions = <TData = Awaited<ReturnType<typeof listWordClouds>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListWordCloudsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWordClouds>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListWordCloudsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWordClouds>>> = ({ signal }) => listWordClouds(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWordClouds>>, TError, TData>
}

export type ListWordCloudsQueryResult = NonNullable<Awaited<ReturnType<typeof listWordClouds>>>
export type ListWordCloudsQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of WordClouds
 */

export function useListWordClouds<TData = Awaited<ReturnType<typeof listWordClouds>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListWordCloudsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWordClouds>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListWordCloudsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete WordCloud
 */
export const deleteWordCloud = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/word_clouds/word_clouds/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteWordCloudMutationKey = () => ['deleteWordCloud'] as const;

export const getDeleteWordCloudMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWordCloud>>, TError,DeleteWordCloudMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteWordCloud>>, TError,DeleteWordCloudMutationVariables, TContext> => {

const mutationKey = getDeleteWordCloudMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWordCloud>>, DeleteWordCloudMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteWordCloud(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteWordCloudMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWordCloud>>>

    export type DeleteWordCloudMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteWordCloudMutationVariables = {id: string}

    /**
 * @summary Delete WordCloud
 */
export const useDeleteWordCloud = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWordCloud>>, TError,DeleteWordCloudMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteWordCloud>>,
        TError,
        DeleteWordCloudMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteWordCloudMutationOptions(options), queryClient);
    }
    /**
 * @summary WordCloud Details
 */
export const getWordCloud = (
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetWordCloudParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<WordCloud>(
      {url: `/word_clouds/word_clouds/${id}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetWordCloudQueryKey = (id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetWordCloudParams>,) => {
    return [
    'word_clouds','word_clouds',id, ...(params ? [params] : [])
    ] as const;
    }


export const getGetWordCloudQueryOptions = <TData = Awaited<ReturnType<typeof getWordCloud>>, TError = ErrorType<void>>(id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetWordCloudParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWordCloud>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetWordCloudQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWordCloud>>> = ({ signal }) => getWordCloud(id,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWordCloud>>, TError, TData>
}

export type GetWordCloudQueryResult = NonNullable<Awaited<ReturnType<typeof getWordCloud>>>
export type GetWordCloudQueryError = ErrorType<void>


/**
 * @summary WordCloud Details
 */

export function useGetWordCloud<TData = Awaited<ReturnType<typeof getWordCloud>>, TError = ErrorType<void>>(
 id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetWordCloudParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWordCloud>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWordCloudQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update WordCloud
 */
export const updateWordCloud = (
    id: MaybeRefOrGetter<string>,
    wordCloudRequestInput: MaybeRefOrGetter<WordCloudRequestInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
wordCloudRequestInput = toValue(wordCloudRequestInput);

      return axiosClient<WordCloud>(
      {url: `/word_clouds/word_clouds/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: wordCloudRequestInput, signal
    },
      );
    }




export const getUpdateWordCloudMutationKey = () => ['updateWordCloud'] as const;

export const getUpdateWordCloudMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWordCloud>>, TError,UpdateWordCloudMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateWordCloud>>, TError,UpdateWordCloudMutationVariables, TContext> => {

const mutationKey = getUpdateWordCloudMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWordCloud>>, UpdateWordCloudMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateWordCloud(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateWordCloudMutationResult = NonNullable<Awaited<ReturnType<typeof updateWordCloud>>>
    export type UpdateWordCloudMutationBody = WordCloudRequestInput
    export type UpdateWordCloudMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateWordCloudMutationVariables = {id: string;data: WordCloudRequestInput}

    /**
 * @summary Update WordCloud
 */
export const useUpdateWordCloud = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWordCloud>>, TError,UpdateWordCloudMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateWordCloud>>,
        TError,
        UpdateWordCloudMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateWordCloudMutationOptions(options), queryClient);
    }
    /**
 * @summary Add Word to WordCloud
 */
export const addWordCloudWord = (
    id: MaybeRefOrGetter<string>,
    wordCloudAddWordRequestInput: MaybeRefOrGetter<WordCloudAddWordRequestInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
wordCloudAddWordRequestInput = toValue(wordCloudAddWordRequestInput);

      return axiosClient<WordCloud>(
      {url: `/word_clouds/word_clouds/${id}/add_word`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: wordCloudAddWordRequestInput, signal
    },
      );
    }




export const getAddWordCloudWordMutationKey = () => ['addWordCloudWord'] as const;

export const getAddWordCloudWordMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addWordCloudWord>>, TError,AddWordCloudWordMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addWordCloudWord>>, TError,AddWordCloudWordMutationVariables, TContext> => {

const mutationKey = getAddWordCloudWordMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addWordCloudWord>>, AddWordCloudWordMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  addWordCloudWord(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddWordCloudWordMutationResult = NonNullable<Awaited<ReturnType<typeof addWordCloudWord>>>
    export type AddWordCloudWordMutationBody = WordCloudAddWordRequestInput
    export type AddWordCloudWordMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type AddWordCloudWordMutationVariables = {id: string;data: WordCloudAddWordRequestInput}

    /**
 * @summary Add Word to WordCloud
 */
export const useAddWordCloudWord = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addWordCloudWord>>, TError,AddWordCloudWordMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof addWordCloudWord>>,
        TError,
        AddWordCloudWordMutationVariables,
        TContext
      > => {
      return useMutation(getAddWordCloudWordMutationOptions(options), queryClient);
    }
